import { GridColDef, GridColumnVisibilityModel } from '@mui/x-data-grid';

import { Submission } from 'common';
import {
  addrCityCol,
  addrCountyCol,
  addrFIPSCol,
  addrLine1Col,
  addrLine2Col,
  addrPostalCol,
  addrStateCol,
  addressSummaryCol,
  annualPremiumCol,
  coordinatesCol,
  createdCol,
  deductibleCol,
  displayNameCol,
  emailCol,
  firstNameCol,
  idCol,
  lastNameCol,
  latitudeCol,
  // ratingDataPriorLossCountCol,
  limitACol,
  limitBCol,
  limitCCol,
  limitDCol,
  longitudeCol,
  priorLossCountCol,
  ratingDataBasementCol,
  ratingDataCBRSCol,
  ratingDataDistToCoastFeetCol,
  ratingDataFloodZoneCol,
  ratingDataNumStoriesCol,
  ratingDataPropertyCodeCol,
  ratingDataReplacementCostCol,
  ratingDataSqFootageCol,
  ratingDataYearBuiltCol,
  tivCol,
  updatedCol,
  userIdCol,
} from './gridColumns';

export const submissionCols: GridColDef<Submission>[] = [
  addressSummaryCol,
  {
    ...addrLine1Col,
    description: 'Submission address to be used for insured location',
  },
  addrLine2Col,
  addrCityCol,
  addrStateCol,
  addrPostalCol,
  addrCountyCol,
  addrFIPSCol,
  annualPremiumCol,
  deductibleCol,
  limitACol,
  limitBCol,
  limitCCol,
  limitDCol,
  tivCol,
  {
    ...displayNameCol,
    sortable: false,
    filterable: false,
    valueGetter: (params) => {
      if (params.value) return params.value;
      // if (params.row.firstName || params.row.lastName)
      // return `${params.row.firstName} ${params.row.lastName}`.trim();
      if (params.row.contact?.firstName || params.row.contact?.lastName)
        return `${params.row.contact?.firstName} ${params.row.contact?.lastName}`.trim();
      return null;
    },
  },
  {
    ...firstNameCol,
    field: 'contact.firstName',
    valueGetter: (params) => params.row.contact?.firstName || null,
    filterable: false,
    sortable: false,
  },
  {
    ...lastNameCol,
    field: 'contact.lastName',
    valueGetter: (params) => params.row.contact?.lastName || null,
    filterable: false,
    sortable: false,
  },
  {
    ...emailCol,
    field: 'contact.email',
    valueGetter: (params) => params.row.contact?.email || null,
    description: 'Provided contact email',
    filterable: false,
    sortable: false,
  },
  // replacementCostCol,
  ratingDataReplacementCostCol,
  {
    field: 'exclusions',
    headerName: 'Exclusions',
    description: 'Exclusions selected by user',
    minWidth: 200,
    flex: 1,
    editable: false,
    filterable: false,
    sortable: false,
    // TODO: valueFormatter
  },
  priorLossCountCol,
  // ratingDataPriorLossCountCol,
  ratingDataDistToCoastFeetCol,
  ratingDataBasementCol,
  ratingDataNumStoriesCol,
  ratingDataPropertyCodeCol,
  ratingDataSqFootageCol,
  ratingDataYearBuiltCol,
  ratingDataFloodZoneCol,
  ratingDataCBRSCol,
  // TODO: only show for admin accounts
  // inlandAALCol,
  // surgeAALCol,
  // tsunamiAALCol,
  coordinatesCol,
  latitudeCol,
  longitudeCol,
  createdCol,
  updatedCol,
  // TODO: admin only ??
  {
    ...idCol,
    field: 'propertyDataDocId',
    headerName: 'Property Data Doc ID',
    description: 'Document ID for the property data response',
    valueGetter: (params) => params.row.propertyDataDocId || null,
    sortable: false,
    filterable: false,
    // ...copyBaseProps,
  },
  {
    ...userIdCol,
    description:
      'user ID of the user that created submission (could have been anonymous if they were not signed in)',
  },
  {
    ...idCol,
    headerName: 'Submission ID',
    description: 'Document/database ID for the submission',
  },
];

export const SUBMISSION_COLUMN_VISIBILITY: GridColumnVisibilityModel = {
  firstName: false,
  lastName: false,
  'address.addressLine1': false,
  'address.addressLine2': false,
  'address.city': false,
  'address.state': false,
  'address.postal': false,
  'address.countyName': false,
  'address.countyFIPS': false,
  'limits.limitA': false,
  'limits.limitB': false,
  'limits.limitC': false,
  'limits.limitD': false,
  latitude: false,
  longitude: false,
  'AALs.inland': false,
  'AALs.surge': false,
  'AALs.tsunami': false,
  'metadata.updated': false,
  'ratingPropertyData.replacementCost': false,
  'ratingPropertyData.propertyCode': false,
  'ratingPropertyData.yearBuilt': false,
  'ratingPropertyData.sqFootage': false,
  'ratingPropertyData.numStories': false,
  'ratingPropertyData.basement': false,
  'ratingPropertyData.distToCoastFeet': false,
  'ratingPropertyData.CBRSDesignation': false,
  'ratingPropertyData.floodZone': false,
  'ratingPropertyData.priorLossCount': false,
  propertyDataDocId: false,
};
